import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Form } from 'formik';
import { Snackbar, Alert } from '@mui/material'; // MUI 컴포넌트 추가
import { 
  listProjectInitBuyTaxbills, 
  listProjectBuyPlan,
  saveProjectBuyTaxbillPlan,
  unloadPurchasePlans  
} from '../../../modules/projectModule/issue-taxbills';
import PurchaseBillPlanList from '../../../components/projectmng/bill_mng/PurchaseBillPlanList';
import dayjs from 'dayjs';

const PurchaseBillPalnContainer = ({ project }) => {
  const dispatch = useDispatch();
  
  // 스낵바 상태 관리
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success', // 'success' | 'error' | 'info' | 'warning'
  });

  const { initBuyTaxbills, purchasePlans, saveResult, error } = useSelector(({ projectModule }) => ({
    initBuyTaxbills: projectModule.issueTaxbills.initBuyTaxbills,
    purchasePlans: projectModule.issueTaxbills.purchasePlans,
    saveResult: projectModule.issueTaxbills.saveResult,
    error: projectModule.issueTaxbills.error,
  }));

useEffect(() => {
    if (project?.prjUuid) {
      dispatch(listProjectInitBuyTaxbills(project.prjUuid));
      dispatch(listProjectBuyPlan(project.prjUuid));
    }

    // 2. 컴포넌트가 닫힐 때(언마운트) 리덕스 데이터 청소
    return () => {
      dispatch(unloadPurchasePlans());
    };
  }, [project?.prjUuid, dispatch]);

  // 저장 결과 감시 및 스낵바 노출
  useEffect(() => { 
     if (saveResult && saveResult.result === 'success') {
     
      setSnackbar({
        open: true,
        message: '매입 내역이 성공적으로 저장되었습니다.',
        severity: 'success',
      });
      dispatch(listProjectBuyPlan(project.prjUuid));
      // 여기서 리덕스의 saveResult를 초기화하는 액션이 있다면 호출 권장
    }
    
    if (error) {
      setSnackbar({
        open: true,
        message: `저장 실패: ${error.message || '다시 시도해주세요.'}`,
        severity: 'error',
      });
    }
  }, [saveResult, error, project?.prjUuid, dispatch]);

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleSave = (formValues) => {
    if (!project?.prjUuid) {
      setSnackbar({ open: true, message: '프로젝트 정보가 없습니다.', severity: 'warning' });
      return;
    }

    const formattedData = formValues.map(plan => ({
      ...plan,
      prjUuid: project.prjUuid,
      usrUuid: project.crtUsr,
      amount: Number(plan.amount || 0),
      reqCompDt: plan.reqCompDt ? dayjs(plan.reqCompDt).format('YYYY-MM-DD') : null,
      payPlanDt: plan.payPlanDt ? dayjs(plan.payPlanDt).format('YYYY-MM-DD') : null,
    }));

    dispatch(saveProjectBuyTaxbillPlan(formattedData));
  };

  return (
    <>
      <Formik
        initialValues={{ purchasePlans: [] }}
        enableReinitialize={true} 
        onSubmit={(values) => handleSave(values.purchasePlans)}
      >
        {({ values }) => (
          <Form>
            <PurchaseBillPlanList 
              taxList={initBuyTaxbills} 
              purchasePlans={purchasePlans} 
              onSave={() => handleSave(values.purchasePlans)} 
            />
          </Form>
        )}
      </Formik>

      {/* 스낵바 알림 컴포넌트 */}
      <Snackbar 
        open={snackbar.open} 
        autoHideDuration={4000} 
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }} variant="filled">
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default PurchaseBillPalnContainer;
